import StatusSelect from "./status-select.component";

export default StatusSelect;
